<template>
  <MotionJump :stiffness="600" :damping="30" :delay="0.1">
    <CardContent theme="neutral-50" stroke="n" class="card-error" elevate="all">
      <template #header>
        <heading class="head" align="center" tag="h1">
          <MotionJump
            key="title"
            :stiffness="350"
            :damping="18"
            :delay="0.1"
            :scale="0"
            :rotation="0"
          >
            Error 40
          </MotionJump>
          <MotionJump
            key="title"
            :stiffness="400"
            :damping="20"
            :delay="0.3"
            :y="-60"
            :scale="0"
          >
            <icon name="fluent-emoji:weary-cat" size="6rem" />
          </MotionJump>
        </heading>
      </template>
      <MotionJump :stiffness="200" :damping="13" :delay="0.1">
        <icon
          name="fluent-emoji:face-with-open-eyes-and-hand-over-mouth"
          size="20rem"
        />
      </MotionJump>
      <p class="description">
        <icon class="hidden-cat" size="4rem" name="fluent-emoji:weary-cat" />

        <MotionJump :stiffness="200" :damping="14" :delay="0.8" :scale="0">
          {{ $t('error.404.description') }}
        </MotionJump>
        <MotionJump :stiffness="400" :damping="18" :delay="1.8" :y="30">
          <icon size="4rem" name="fluent-emoji:face-with-diagonal-mouth" />
        </MotionJump>
      </p>
      <MotionJump
        :stiffness="250"
        :damping="30"
        :delay="0.5"
        :y="200"
        :scale="1"
      >
        <ButtonBase stroke="n" @click="handleError">
          Retour à la page d'accueil
        </ButtonBase>
      </MotionJump>
    </CardContent>
  </MotionJump>
</template>
<script setup lang="ts">
defineProps({
  error: Object,
});
const handleError = () => clearError({ redirect: '/' });
</script>
<style lang="scss" scoped>
.card-error {
  width: calc(100% - 4rem);
  overflow: hidden;
  @include above('l') {
    width: 54rem;
  }
  img {
    border-radius: 0.8rem;
  }
  p {
    @include font('m', 800);

    // overflow: hidden;
    color: var(--color_neutral_600);
    text-align: center;
  }
  p,
  .head {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.8rem;
  }
  .head {
    gap: 0;
  }
  .hidden-cat {
    visibility: hidden;
  }
}
</style>
